import { type ManagedBy, type RawManagedBy } from '../domain/ManagedBy'

export function mapApiToManagedBy(rawManagedBy: RawManagedBy): ManagedBy {
  if (!rawManagedBy) {
    return undefined
  }

  return {
    contactName: rawManagedBy.contact_name,
    contactEmail: rawManagedBy.contact_email,
    contactPhone: rawManagedBy.contact_phone ?? undefined,
  }
}
